module.exports = __webpack_public_path__ + "img/themes-4k.5bc69058.webp";